import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VerificationService } from '../../../Model/Verification/verification.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { NgOtpInputModule } from 'ng-otp-input';
import { interval } from 'rxjs'

@Component({
  selector: 'app-mobile-email',
  standalone: true,
  imports: [CommonModule, FormsModule, NgOtpInputModule],
  templateUrl: './mobile-email.component.html',
  styleUrl: './mobile-email.component.scss'
})
export class MobileEmailComponent {
  isDisabled: boolean = false;
  Banks = [] as any;
  @Input() IsDraft: boolean = false;
  @Input() EmpTempCode: String = '';
  @Input() EmailId: String = '';
  @Input() TypeID: number = 0;
  @Input() EmpMasterId: number = 0;

  OTP: string = null as any;
  showPassword = false;

  timer: any;
  timingsixty = 60;
  otpButtonDisable = false;


  constructor(
    private toast: ToastService,
    private activeModal: NgbActiveModal,
    private verification: VerificationService,
  ) { }

  ngOnInit(): void {
    this.EmpEmailOtpVerify();
  }

  Verification(form: any) {
    if (form.valid) {
      this.isDisabled = true;
      this.Verify();
    } else {
      form.submitted = true;
    }
  }

  EmpEmailOtpVerify() {
    this.isDisabled = true;
    this.otpButtonDisable = true;
    if (this.TypeID == 1) {
      this.verification.EmpMobileOtpVerify({ IsDraft: this.IsDraft, SelectType: 'UpdateOTP', EmpCode: this.EmpTempCode, MobileNo: this.EmailId, OTP: '', EmpMasterId: this.EmpMasterId }).subscribe({
        next: (response) => {
          if (response.Error_Code == '01') {
            this.toast.show({ message: 'OTP Sent Successfully', type: toastTypeEnum.success });
            this.timingsixty = 60;
            this.timer = interval(1000).subscribe((val) => {
              this.timingsixty -= 1;
              if (this.timingsixty == 0) {
                this.otpButtonDisable = false;
                this.timer.unsubscribe();
              }
            });
          } else {
            this.otpButtonDisable = false;
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.otpButtonDisable = false;
          this.isDisabled = false;
        },
      });
    } else {
      this.verification.EmpEmailOtpVerify({ IsDraft: this.IsDraft, SelectType: 'UpdateOTP', EmpCode: this.EmpTempCode, EmailId: this.EmailId, OTP: '', EmpMasterId: this.EmpMasterId }).subscribe({
        next: (response) => {
          if (response.Error_Code == '01') {
            this.toast.show({ message: 'OTP Sent Successfully', type: toastTypeEnum.success });
            this.timingsixty = 60;
            this.timer = interval(1000).subscribe((val) => {
              this.timingsixty -= 1;
              if (this.timingsixty == 0) {
                this.otpButtonDisable = false;
                this.timer.unsubscribe();
              }
            });
          } else {
            this.otpButtonDisable = false;
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.otpButtonDisable = false;
          this.isDisabled = false;
        },
      });
    }
  }

  Verify() {
    this.isDisabled = true;
    if (this.TypeID == 1) {
      this.verification.EmpMobileOtpVerify({ IsDraft: this.IsDraft, SelectType: 'VerifyMobile', EmpCode: this.EmpTempCode, MobileNo: this.EmailId, OTP: this.OTP, EmpMasterId: this.EmpMasterId }).subscribe({
        next: (response) => {
          if (response.Error_Code == '17') {
            this.activeModal.close(true);
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
          } else {
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.verification.EmpEmailOtpVerify({ IsDraft: this.IsDraft, SelectType: 'VerifyEmail', EmpCode: this.EmpTempCode, EmailId: this.EmailId, OTP: this.OTP, EmpMasterId: this.EmpMasterId }).subscribe({
        next: (response) => {
          if (response.Error_Code == '17') {
            this.activeModal.close(true);
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
          } else {
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    }
  }

  close() {
    this.activeModal.close();
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  onOtpChange(event: any) {
    this.OTP = event;
  }
}
